import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  catAttributes: [],
  loading: false,
  error: null,
};

const getCatAttributeSlice = createSlice({
  name: "getCatAttribute",
  initialState,
  reducers: {
    fetchCatAttributeStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchCatAttributeSuccess: (state, action) => {
      state.loading = false;
      state.catAttributes = action.payload;
    },

    fetchCatAttributeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchCatAttributeStart,
  fetchCatAttributeSuccess,
  fetchCatAttributeFailure,
} = getCatAttributeSlice.actions;

export default getCatAttributeSlice.reducer;
